import { reportTypesForFeatures, type ReportType } from "@visioni/a3s-reports/client-messages";
import type { TenantFeatures } from "@src/features/tenants";

/**
 * Which report tiles a tenant is entitled to, as a phase rather than a list.
 *
 * `pending` is kept distinct from an empty `ready` on purpose. Collapsing them
 * would render the "no reports" empty state on every cold deep-link before the
 * camera list arrives, and then flip to tiles - the same failure the
 * clip-compilation access hook's docblock describes for `pending` vs `denied`.
 */
export type ReportEntitlements =
  | { readonly status: "pending" }
  | { readonly status: "error"; readonly message: string }
  | { readonly status: "ready"; readonly reportTypes: readonly ReportType[] };

/**
 * Project the tenant's features onto the reports they grant.
 *
 * Pure, so it can be unit tested without the React Native module graph.
 */
export function resolveReportEntitlements(features: TenantFeatures): ReportEntitlements {
  if (features.status === "pending") return { status: "pending" };
  if (features.status === "error") return { status: "error", message: features.message };

  return { status: "ready", reportTypes: reportTypesForFeatures([...features.held]) };
}
